import { render, staticRenderFns } from "./priorityStatus.vue?vue&type=template&id=8d3839c0&"
import script from "./priorityStatus.vue?vue&type=script&lang=js&"
export * from "./priorityStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports